angular.module('businessThread')
    .component('businessThreadPanel', {
        bindings: {
            resourceType: '@',
            resourceId: '<',
            linkCount: '=?'
        },
        templateUrl: 'app/business-thread/thread-panel.html',
        controller: function ($scope, BusinessThread, BusinessThreadService, BusinessThreadLinkFlagService, BusinessThreadConst, Principal, toastr, modals) {
            this.$onInit = () => {
                this.links = []
                this.flags = BusinessThreadLinkFlagService.flags
                this.updateLinkCount()
                this.canUseBusinessThreads = false

                Principal.identity().then(() => {
                    this.canUseBusinessThreads = Principal.hasAnyAuthority([BusinessThreadConst.RoleModule])
                    if (this.canUseBusinessThreads) {
                        this.load()
                    }
                })
            }

            this.$onChanges = changes => {
                if (this.canUseBusinessThreads && changes.resourceId && !changes.resourceId.isFirstChange()) {
                    this.load()
                }
            }

            this.load = () => {
                if (!this.canUseBusinessThreads || !this.resourceType || !this.resourceId) {
                    this.links = []
                    this.updateLinkCount()
                    return
                }

                return BusinessThread.resourceLinks({
                    resourceType: this.resourceType,
                    resourceId: this.resourceId
                }).$promise.then(items => {
                    this.links = items || []
                    this.updateLinkCount()
                })
            }

            this.attach = thread => {
                if (!this.canUseBusinessThreads || !thread || !thread.id) {
                    return
                }

                return BusinessThread.link({id: thread.id}, {
                    resourceType: this.resourceType,
                    resourceId: this.resourceId
                }).$promise.then(() => {
                    toastr.success('Powiązano wątek biznesowy')
                    return this.load()
                }).catch(() => toastr.error('Nie udało się powiązać wątku biznesowego'))
            }

            this.linkExisting = () => {
                if (!this.canUseBusinessThreads) {
                    return
                }

                return BusinessThreadService.selectExisting({
                    linkedIds: this.links.map(link => link.threadId),
                    resourceType: this.resourceType,
                    resourceId: this.resourceId
                }).then(thread => this.attach(thread)).catch(angular.noop)
            }

            this.editThread = link => {
                if (!this.canUseBusinessThreads || !link || !link.thread) {
                    return
                }

                return BusinessThreadService.edit(link.thread).then(() => this.load()).catch(angular.noop)
            }

            this.unlink = link => {
                if (!this.canUseBusinessThreads || !link || !link.id || !link.threadId) {
                    return
                }

                let label = link.thread && link.thread.symbol ? link.thread.symbol : 'wybrany wątek'
                return modals.confirm('Czy na pewno odpiąć powiązanie z wątkiem biznesowym <strong>' + label + '</strong>?', () => BusinessThread.unlink({
                    id: link.threadId,
                    linkId: link.id
                }).$promise.then(() => this.load()))
            }

            this.toggleFlag = (link, flag) => {
                if (!this.canUseBusinessThreads) {
                    return
                }

                return BusinessThreadLinkFlagService.toggleFlag(link, flag)
            }

            this.linkTrackKey = link => link ? [link.id, BusinessThreadLinkFlagService.value(link) || 'none'].join(':') : ''
            this.hasLinks = () => this.links && this.links.length > 0
            this.updateLinkCount = () => this.linkCount = this.links ? this.links.length : 0

            $scope.$on(BusinessThreadConst.eventLinkUpdate, () => this.load())
        }
    })
